<template>
  <div class="premium-banner flex">
    <img :src="require(`@/assets/images/membership/rosette.svg`)" class="inline-block" />

    <div class="">
      <h2 class="text-lg font-bold">Your Gold Membership is due to expire on {{ compExpireData }}</h2>

      <p class="text-sm mt-3">When this happens you will have the option to choose a Gold or Silver plan or,
        if you decide against this, you'll automatically become a Bronze member.</p>
    </div>
  </div>
</template>

<script>
  export default {
  name: 'WidgetPremiumExpireBanner',

  computed: {
    compExpireData() {
      return this.$date(this.app.subscriptions[0].nextPaymentDate, this.$date.legacyFormatDateOnly).format('DD/MM/YYYY')
    }
  }
}
</script>

<style lang="scss" scoped>
.premium-banner {
  max-width: 782px;
  width: 100%;
  padding: 16px;
  color: #ffffff;
  background-color: #334050;

  img {
    height: 33px;
    margin-top: 5px;
    margin-right: 25px;
  }

  p {
    color: #E5E7EB;
  }

  .link {
    text-decoration: underline;
    color: #E5E7EB;
  }
}
</style>
